import { GlButton, GlIcon, GlSkeletonLoader, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { isLoggedIn } from '~/lib/utils/common_utils';
import { s__ } from '~/locale';
import ImportedBadge from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/imported_badge.vue?vue3';
import TodosToggle from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/components/shared/todos_toggle.vue?vue3';
import ArchiveDesignButton from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/components/design_management/archive_design_button.vue?vue3';
import CloseButton from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/components/design_management/design_preview/close_button.vue?vue3';
import DesignNavigation from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/components/design_management/design_preview/design_navigation.vue?vue3';
export default {
    name: 'DesignToolbar',
    i18n: {
        downloadButtonLabel: s__('DesignManagement|Download design'),
        hideCommentsButtonLabel: s__('DesignManagement|Hide comments'),
        showCommentsButtonLabel: s__('DesignManagement|Show comments'),
        archiveButtonLabel: s__('DesignManagement|Archive design')
    },
    components: {
        GlButton,
        GlIcon,
        GlSkeletonLoader,
        ImportedBadge,
        CloseButton,
        DesignNavigation,
        TodosToggle,
        ArchiveDesignButton
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        design: {
            type: Object,
            required: true
        },
        designFilename: {
            type: String,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        },
        isLatestVersion: {
            type: Boolean,
            required: true
        },
        isSidebarOpen: {
            type: Boolean,
            required: true
        },
        allDesigns: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        currentUserDesignTodos: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        canUpdateDesign: {
            type: Boolean,
            required: false
        },
        isTodoUpdating: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'archive-design',
        'toggle-todo',
        'toggle-sidebar'
    ],
    computed: {
        isLoggedIn () {
            return isLoggedIn();
        },
        toggleCommentsButtonLabel () {
            return this.isSidebarOpen ? this.$options.i18n.hideCommentsButtonLabel : this.$options.i18n.showCommentsButtonLabel;
        }
    }
};
